import { OPEN_MODAL, CLOSE_MODAL } from 'actionTypes';

const initialState = {
  name: null,
  isOpen: false,
};

export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...action.modal,
        isOpen: true,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js